/* eslint-disable no-plusplus */
import debounce from '../util/debounce';

export default class BreadcrumbModifier {
  constructor() {
    this.breadcrumb = document.querySelector('.woocommerce-breadcrumb');
    if (!this.breadcrumb) return;
    this.originalBreadcrumb = this.breadcrumb.cloneNode(true);
    this.isModified = false;
    this.handleBreadcrumb = this.handleBreadcrumb.bind(this);
    this.destroy = this.destroy.bind(this);
    this.debounce = debounce;
    this.init();
  }

  init() {
    this.handleBreadcrumb();
    window.addEventListener('resize', this.debounce(this.handleBreadcrumb, 250));
  }

  handleBreadcrumb() {
    if (window.innerWidth < 768 && !this.isModified) {
      let children = Array.from(this.breadcrumb.childNodes);
      const firstLinkIndex = children.findIndex((child) => child.nodeName === 'A');
      const firstIconIndex = children.findIndex(
        (child, i) => i > firstLinkIndex && child.nodeName === 'DIV' && child.classList.contains('icon')
      );
      const lastTextIndex = children
        .reverse()
        .findIndex((child) => child.nodeName === '#text' && child.textContent.trim() !== '');
      const lastIconIndex = children.findIndex(
        (child, i) => i > lastTextIndex && child.nodeName === 'DIV' && child.classList.contains('icon')
      );
      children.reverse();
      for (let i = firstIconIndex + 1; i < children.length - lastIconIndex - 1; i++) {
        this.breadcrumb.removeChild(children[i]);
      }
      children = Array.from(this.breadcrumb.childNodes);
      const ellipsis = document.createTextNode('...');
      this.breadcrumb.insertBefore(ellipsis, children[firstIconIndex + 1]);
      this.isModified = true;
    } else if (window.innerWidth >= 768 && this.isModified) {
      this.breadcrumb.innerHTML = this.originalBreadcrumb.innerHTML;
      this.isModified = false;
    }
  }

  destroy() {
    window.removeEventListener('resize', this.debounce(this.handleBreadcrumb, 250));
    if (this.isModified) {
      this.breadcrumb.innerHTML = this.originalBreadcrumb.innerHTML;
      this.isModified = false;
      this.breadcrumb = null;
      this.originalBreadcrumb = null;
      this.isModified = null;
      this.handleBreadcrumb = null;
      this.destroy = null;
      this.debounce = null;
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/breadcrumbModifier.js